import React from 'react';

function HeightIcon(props) {
    return (
        <svg width="47" height="49" viewBox="0 0 47 49" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.15" y="0.298767" width="47" height="48.5602" rx="5" fill="#4A37C2"/>
            <g clip-path="url(#clip0_0_1)">
                <path d="M30.2969 12.3253H16.7031V14.14H23.4398L18.647 18.7788L19.9728 20.062L22.5156 17.601V30.2961L19.9728 27.835L18.647 29.1182L23.4216 33.7394H16.7031V35.5542H30.2969V33.7394H23.4846L28.2593 29.1182L26.9334 27.835L24.3906 30.2961V17.601L26.9334 20.062L28.2593 18.7788L23.4664 14.14H30.2969V12.3253Z" fill="#4A37C2"/>
            </g>
            <defs>
                <clipPath id="clip0_0_1">
                    <rect width="24" height="23.2289" fill="white" transform="translate(11.5 12.3253)"/>
                </clipPath>
            </defs>
        </svg>

    );
}

export default HeightIcon;
